import {fromLonLat} from "ol/proj";
import {LineString, MultiPolygon, Point, Polygon} from "ol/geom";
import {Feature} from "ol";

export const createFeatureFromCoordinates = (coordinates, name = null, type = 'Polygon') => {
    let coordinatesArray = [];
    let geo;
    let points = coordinates.split(" ");

    //sprawdzenie czy to multipolygon
    if (coordinates.includes('|') || coordinates.includes("?")) {

        //tablica elementów multiPolygonu, które są od siebie odległe (nie jeden w drugim)
        let distantPolygonsArray = coordinates.split("?");

        for (let i = 0; i < distantPolygonsArray.length; i++) {
            coordinatesArray[i] = [];
        }

        for (let i = 0; i < distantPolygonsArray.length; i++) {
            //tablica elementów multiPolygonu które są jeden w drugim
            let insideCoordinatesArray = distantPolygonsArray[i].split("|");

            for (let j = 0; j < insideCoordinatesArray.length; j++) {
                coordinatesArray[i][j] = insideCoordinatesArray[j].split(" ").filter(coords => coords !== "").map(coord => fromLonLat(coord.split(",")));
            }
        }
        geo = new MultiPolygon(coordinatesArray);
    } else if(points.length <= 2 && type !== 'LineString') {
        geo = new Point(fromLonLat(points));
    } else {
        if(type === 'LineString') {
            coordinatesArray = points.filter(coords => coords !== "").map(coord => fromLonLat(coord.split(",")));
            geo = new LineString(coordinatesArray);
        } else {
            coordinatesArray = [points.filter(coords => coords !== "").map(coord => fromLonLat(coord.split(",")))];
            geo = new Polygon(coordinatesArray);
        }
    }

    return new Feature({
        geometry: geo,
        name,
        changed: false
    });
}
